import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AutocompleteField from "../../field/AutocompleteField";
import { height } from "@mui/system";

export const EmailRecipientsSelect = (props) => {
    const { emailOptions, seletedEmails, setSelectedEmails } = props;
    const { t } = useTranslation();

    return (
        <AutocompleteField
            name={"emails"}
            label={t("SendEmailDialog.emailRecipients")}
            value={seletedEmails}
            options={emailOptions}
            isObjectOption={false}
            onChange={setSelectedEmails}
            addNewValue={false}
            multiple={true}
            textFieldSize="medium"
        />
    );
};
